import React, { useState, useRef, useEffect, useCallback } from 'react';
import { PartGroup } from './PartGroup';

export const Category = ({
    category, value, imageUrl, chosenCategory, setChosenCategory, getPartPartGroupUrl, setPaddingBottom
}) => {
    const [chosenPartGroup, setChosenPartGroup] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const partGroupContainerRef = useRef(null);
    const [categoryHover, setCategoryHover] = useState(false);

    const largeScreen = 870;

    const isLargeScreenAndChosenCategory = (chosenCategory, category) => {
        return chosenCategory === category && windowWidth >= largeScreen;
    };

    useEffect(() => {
        if (partGroupContainerRef.current) {
            const accordionContent = document.getElementById('partSearchAccordionContent');
            const partGroupContainer = partGroupContainerRef.current;
            if (accordionContent && partGroupContainer) {
                const accordionContentPosition = accordionContent.getBoundingClientRect();
                const partGroupContainerPosition = partGroupContainer.getBoundingClientRect();

                const partGroupOverflowHeight = partGroupContainerPosition.top + partGroupContainerPosition.height -
                    (accordionContentPosition.top + accordionContentPosition.height);
                setPaddingBottom((prev) => Math.max(0, (prev + partGroupOverflowHeight + 20)));
            }
        }
    }, [chosenCategory, category, setPaddingBottom, partGroupContainerRef, chosenPartGroup]);

    const handleResize = useCallback(() => {
        setWindowWidth(window.innerWidth);
    }, []);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    const handleCategoryClick = useCallback(() => {
        if (chosenCategory === category) {
            setPaddingBottom(0);
            setChosenPartGroup("");
        }
        setChosenCategory(chosenCategory === category ? '' : category);
    }, [chosenCategory, category, setChosenCategory, setPaddingBottom]);

    const setCaretSource = (chosenCategory, category) => {
        if (windowWidth >= largeScreen && categoryHover) {
            return "/images/CaretDownGreen.svg";
        }
        if (isLargeScreenAndChosenCategory(chosenCategory, category)) {
            return "/images/CaretDownGreen.svg";
        }
        return "/images/CaretDownBlue.svg";
    };

    return (
        <li key={category} className="partCategoryListItemWrapper">
            <div className='partCategoryContainer'>
                <div
                    className="partsCategoryListItem"
                    onClick={handleCategoryClick}
                    onMouseEnter={() => setCategoryHover(true)}
                    onMouseLeave={() => setCategoryHover(false)}
                    style={isLargeScreenAndChosenCategory(chosenCategory, category)
                        ? {
                            boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.25)',
                            border: '2px solid #69B356',
                            position: 'relative',
                        }
                        : {}}
                >
                    <div className="partsCategoryItemContent">
                        <img className="partListItemImage" src={imageUrl} />
                        <div className='partCategoryTitle'>
                            <div className="partListItemTitleContainer">
                                <h2 className="partListItemTitle"
                                    style={isLargeScreenAndChosenCategory(chosenCategory, category) ? { color: "#457B37" } : {}}
                                >
                                    {category}
                                    <img
                                        className={chosenCategory === category ? "partListItemArrowOpen partListItemArrow" : "partListItemArrow"}
                                        src={setCaretSource(chosenCategory, category)} />
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                {chosenCategory === category && (
                    <div className='partGroupContainer' ref={partGroupContainerRef}>
                        <ul className="bordered-list">
                            {value.map((partGroup) => {
                                if (chosenPartGroup !== "" && chosenPartGroup !== partGroup.Name) { return null; }
                                return (
                                    <PartGroup
                                        key={partGroup.Name}
                                        partGroup={partGroup}
                                        chosenPartGroup={chosenPartGroup}
                                        setChosenPartGroup={setChosenPartGroup}
                                        getPartPartGroupUrl={getPartPartGroupUrl} />
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        </li>
    );
};
